import { render, staticRenderFns } from "./SubDrawer.vue?vue&type=template&id=85951e6e&scoped=true"
import script from "./SubDrawer.vue?vue&type=script&lang=ts"
export * from "./SubDrawer.vue?vue&type=script&lang=ts"
import style0 from "./SubDrawer.vue?vue&type=style&index=0&id=85951e6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85951e6e",
  null
  
)

export default component.exports